import { Injectable } from '@angular/core';
import { Appointment } from '../models/appointment.model';
import { AppComponent } from '../app.component';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AppointmentEditorService {
  

  private appComponent!: AppComponent;

  constructor(
    private location: Location
  ) { }

  setOpen(newAppointment: Appointment){
    this.appComponent.getAppointmentEditor().appointment = newAppointment
    this.appComponent.getAppointmentEditor().initAppointment()
   
  }

  dismiss(){
    this.removeUrlParam("appt")
    this.removeUrlParam("edit")
  }

  registerComponent(component: AppComponent){
    this.appComponent = component
  }

  removeUrlParam(paramToRemove: string) {
    // Get the current URL path
    const currentPath = this.location.path().split('?')[0];
  
    // Get the current query parameters
    const searchParams = new URLSearchParams(this.location.path().split('?')[1]);
  
    // Delete the parameter you want to remove
    searchParams.delete(paramToRemove);
  
    // Construct the new query string
    const queryParams = searchParams.toString();
  
    // Update the URL
    this.location.replaceState(`${currentPath}?${queryParams}`);
  }

  addUrlParam(paramToAdd: string, value: string) {
    // Get the current URL path
    const currentPath = this.location.path().split('?')[0];
  
    // Get the current query parameters
    const searchParams = new URLSearchParams(this.location.path().split('?')[1]);
  
    // Delete the parameter you want to remove
    searchParams.append(paramToAdd, value);
  
    // Construct the new query string
    const queryParams = searchParams.toString();
  
    // Update the URL
    this.location.replaceState(`${currentPath}?${queryParams}`);
  }
}
